import { forwardRef } from "react";
import cn from "mcn";

export const LiveChartsAlertOffIcon = forwardRef<
  SVGSVGElement,
  React.HTMLAttributes<SVGSVGElement> & {
    selected?: boolean;
    disableHover?: boolean;
    size?: string;
    disabled?: boolean;
  }
>(({ selected, disableHover, size, disabled, ...props }, ref) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: We have a custom tooltip
    <svg
      width={size ?? "30"}
      height={size ?? "30"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn(
        selected ? "nav-icon selected group" : "nav-icon group",
        props.className,
        "rounded-full",
        disabled ? "bg-[var(--new-neutral-t50)] rounded-full" : "",
        "hover:bg-[var(--neutral-tonal)] hover:rounded-full focus:bg-[var(--neutral-tonal)] focus:rounded-full focus:border focus:border-[var(--neutral-default,#5E5E5E)]",
      )}
      ref={ref}
    >
      <path
        d="M7.82489 6.97752C7.58989 6.74252 7.20989 6.74252 6.97739 6.97752C6.74489 7.21252 6.74239 7.59252 6.97489 7.82752L20.1749 21.0275C20.4099 21.2625 20.7899 21.2625 21.0224 21.0275C21.2549 20.7925 21.2574 20.4125 21.0224 20.18L18.8274 17.985C19.2649 17.9025 19.5974 17.5175 19.5974 17.0575C19.5974 16.89 19.5524 16.725 19.4699 16.5825L18.9249 15.6425C18.4499 14.8275 18.1999 13.9025 18.1999 12.96V12.5975C18.1999 10.4825 16.6349 8.73002 14.5999 8.44002V8.19752C14.5999 7.86502 14.3324 7.59752 13.9999 7.59752C13.6674 7.59752 13.3999 7.86502 13.3999 8.19752V8.44002C12.3449 8.59002 11.4149 9.13502 10.7649 9.91752L7.82489 6.97752ZM11.6199 10.7725C12.1674 10.06 13.0299 9.60002 13.9999 9.60002C15.6574 9.60002 16.9999 10.9425 16.9999 12.6V12.9625C16.9999 14.1175 17.3074 15.25 17.8874 16.2475L18.2099 16.8H17.6449L11.6174 10.7725H11.6199ZM10.1124 16.2475C10.5999 15.4125 10.8949 14.48 10.9774 13.5225L9.80989 12.355C9.80489 12.4375 9.80239 12.52 9.80239 12.6025V12.965C9.80239 13.9075 9.55239 14.8325 9.07739 15.6475L8.52739 16.58C8.44239 16.725 8.39989 16.8875 8.39989 17.055C8.39989 17.5775 8.82239 18 9.34489 18H15.4549L14.2549 16.8H9.78989L10.1124 16.2475ZM12.3024 19.2C12.5499 19.9 13.2174 20.4 13.9999 20.4C14.7824 20.4 15.4499 19.9 15.6974 19.2H12.3024Z"
        style={disableHover ? { fill: "var(--neutral-default)" } : undefined}
        className={`${disableHover ? "" : "fill-[var(--neutral-default)] group-hover:fill-[var(--neutral-on-tonal)]"}`}
      />
    </svg>
  );
});
